import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Interceptor que agrega headers de no-cache a las peticiones
 * NOTA: NO se aplica a endpoints de clave-unica porque:
 * - Los headers personalizados causan peticiones preflight OPTIONS
 * - Puede causar errores de CORS si el backend no maneja OPTIONS correctamente
 * - Ya usamos timestamp en la URL (?_t=...) para evitar cache
 */
export const noCacheInterceptor: HttpInterceptorFn = (req, next) => {
  // ⚠️ NO aplicar a endpoints de clave-unica para evitar problemas de CORS
  if (req.url.includes('clave-unica')) {
    return next(req);
  }

  const noCacheReq = req.clone({
    setHeaders: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
  });

  return next(noCacheReq);
};
